/**
 * Apollo InMemoryCache type policies.
 *
 * erpWorkOrderOperation has no id, so it is stored inline under its root field
 * rather than normalized. Several queries select different fields of the same
 * operation (GET_WORK_ORDER_OPERATION_CUSTOM_FIELDS for material picking,
 * GET_SELECTED_WORK_ORDER_OPERATION for the change-job flow); by default each
 * write replaces the other's fields, so the watching query loses its data and
 * refetches. Merging keeps both sets of fields.
 */
export const typePolicies = {
  Query: {
    fields: {
      erpWorkOrderOperation: {
        merge: true,
      },
    },
  },
};
